"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _helpers = require("./../../utils/helpers");
function GenericList({
  list = [],
  type = 'unordered',
  // 'unordered' | 'ordered'
  classname = ''
}) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _helpers.classes)(['generic-list', `${classname}`])
  }, list.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _helpers.classes)(['generic-list__item', `${classname}__item`]),
      key: classname === '' ? `generic-list-${index}` : `${classname}-${index}`
    }, typeof item === 'string' && item !== '' ? (0, _htmlReactParser.default)(item) : item);
  }));
}
var _default = exports.default = GenericList;